import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import ScheduleInterviewModal from '../ScheduleInterviewModal';
import { putRequest, getRequest } from '../../requestUtils';
import './ConfirmModal.scss';
var ConfirmModal = /*#__PURE__*/function (_Component) {
  function ConfirmModal(props) {
    var _this;
    _classCallCheck(this, ConfirmModal);
    _this = _callSuper(this, ConfirmModal, [props]);
    _this.state = {
      showConfirmModal: false,
      showInterviewModal: false,
      reasons: [],
      internalNotes: ''
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleInterviewModalClose = _this.handleInterviewModalClose.bind(_this);
    return _this;
  }
  _inherits(ConfirmModal, _Component);
  return _createClass(ConfirmModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var statusChangeId = this.props.statusChangeId;
      if (!statusChangeId) return;
      getRequest("/status_changes/".concat(statusChangeId)).then(function (response) {
        _this2.setState({
          reasons: response.data.internal_feedbacks,
          internalNotes: response.data.change_reason
        });
      });
    }
  }, {
    key: "handleInterviewModalClose",
    value: function handleInterviewModalClose() {
      this.setState({
        showInterviewModal: false
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props = this.props,
        type = _this$props.type,
        csrfToken = _this$props.csrfToken,
        submitUrl = _this$props.submitUrl,
        isEditing = _this$props.isEditing,
        statusChangeId = _this$props.statusChangeId,
        handleProposalAfterSubmit = _this$props.handleProposalAfterSubmit;
      var _this$state = this.state,
        reasons = _this$state.reasons,
        internalNotes = _this$state.internalNotes;
      if (type === 'interview' && !isEditing) {
        this.setState({
          showConfirmModal: false,
          showInterviewModal: true
        });
        return;
      }
      var url = isEditing ? "/status_changes/".concat(statusChangeId) : submitUrl;
      var params;
      if (isEditing) {
        params = {
          status_change: {
            change_reason: internalNotes,
            internal_feedback_ids: reasons.map(function (reason) {
              return reason.value;
            })
          }
        };
      } else {
        params = {
          reason: internalNotes,
          internal_feedback_ids: reasons.map(function (reason) {
            return reason.value;
          })
        };
      }
      putRequest(url, params, csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this3.setState({
          showConfirmModal: false
        });
        handleProposalAfterSubmit(data);
      })["catch"](function () {
        return null;
      });
    }
  }, {
    key: "renderScheduleInterviewModal",
    value: function renderScheduleInterviewModal() {
      var _this$props2 = this.props,
        submitUrl = _this$props2.submitUrl,
        csrfToken = _this$props2.csrfToken,
        proposalResourceId = _this$props2.proposalResourceId,
        consultantName = _this$props2.consultantName,
        possibleInterviewers = _this$props2.possibleInterviewers,
        invitableRoles = _this$props2.invitableRoles,
        availableInterviewSlotUrl = _this$props2.availableInterviewSlotUrl;
      var _this$state2 = this.state,
        reasons = _this$state2.reasons,
        internalNotes = _this$state2.internalNotes;
      return /*#__PURE__*/React.createElement(ScheduleInterviewModal, {
        createInterviewUrl: submitUrl,
        proposalResourceId: proposalResourceId,
        csrfToken: csrfToken,
        consultantName: consultantName,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        modalTriggerType: "link",
        showModal: true,
        reasons: reasons.map(function (reason) {
          return reason.value;
        }),
        internalNotes: internalNotes,
        showModalTrigger: false,
        availableInterviewSlotUrl: availableInterviewSlotUrl,
        handleInterviewModalClose: this.handleInterviewModalClose
      });
    }
  }, {
    key: "renderModalHeading",
    value: function renderModalHeading() {
      var type = this.props.type;
      var text = type === 'interview' ? 'interview request' : type;
      return /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Confirm", ' ', text);
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this4 = this;
      var _this$props3 = this.props,
        type = _this$props3.type,
        reasonOptions = _this$props3.reasonOptions;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "required"
      }, "Indicate primary reason(s) employer would like to", ' ', type, ' ', "this candidate:"), /*#__PURE__*/React.createElement(Select, {
        classNamePrefix: "clora-multiselect",
        closeMenuOnSelect: false,
        value: this.state.reasons || [],
        isMulti: true,
        className: "reason-select mt-3",
        onChange: function onChange(options) {
          return _this4.setState({
            reasons: options
          });
        },
        isDisabled: false,
        placeholder: "Choose an option",
        hideSelectedOptions: false,
        options: reasonOptions
      }));
    }
  }, {
    key: "renderTextBox",
    value: function renderTextBox() {
      var _this5 = this;
      var type = this.props.type;
      var text = type === 'interview' ? 'interview request' : type;
      return /*#__PURE__*/React.createElement("div", {
        className: "pt-3 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "required"
      }, "Internal notes about", ' ', text, ":"), /*#__PURE__*/React.createElement("textarea", {
        className: "form-control fs-hide null mt-3",
        required: "required",
        onChange: function onChange(e) {
          return _this5.setState({
            internalNotes: e.target.value
          });
        },
        value: this.state.internalNotes || ''
      }));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props4 = this.props,
        type = _this$props4.type,
        isEditing = _this$props4.isEditing;
      var _this$state3 = this.state,
        reasons = _this$state3.reasons,
        internalNotes = _this$state3.internalNotes;
      var disabledState = isEditing ? false : reasons.length < 1 || internalNotes.length < 3;
      var buttonText;
      if (isEditing) {
        buttonText = 'Save';
      } else if (type === 'interview') {
        buttonText = 'Request interview';
      } else {
        buttonText = type[0].toUpperCase() + type.substring(1);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "g-row mt-4 gap-20"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, "Cancel")), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit,
        disabled: disabledState
      }, buttonText)));
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this6 = this;
      var showInterviewModal = this.state.showInterviewModal;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showConfirmModal,
        onHide: function onHide() {
          return _this6.setState({
            showConfirmModal: false
          });
        },
        dialogClassName: "confirm-modal",
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "padded-modal-content style-guide"
      }, this.renderModalHeading(), this.renderDropdown(), this.renderTextBox(), this.renderButtons())), showInterviewModal && this.renderScheduleInterviewModal());
    }
  }, {
    key: "renderModalTrigger",
    value: function renderModalTrigger() {
      var _this7 = this;
      var _this$props5 = this.props,
        buttonType = _this$props5.buttonType,
        modalTriggerCopy = _this$props5.modalTriggerCopy,
        modalTriggerType = _this$props5.modalTriggerType;
      if (modalTriggerType === 'button') {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn ".concat(buttonType),
          onClick: function onClick() {
            return _this7.setState({
              showConfirmModal: true
            });
          }
        }, modalTriggerCopy);
      }
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "confirm-modal-cta",
        onClick: function onClick() {
          return _this7.setState({
            showConfirmModal: true
          });
        }
      }, modalTriggerCopy);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "confirm-modal-container"
      }, this.renderModalTrigger(), this.renderModal());
    }
  }]);
}(Component);
ConfirmModal.propTypes = {
  submitUrl: PropTypes.string,
  proposalResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string.isRequired,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  modalTriggerType: PropTypes.oneOf(['button', 'link']),
  buttonType: PropTypes.string,
  modalTriggerCopy: PropTypes.string.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
  statusChangeId: PropTypes.number,
  isEditing: PropTypes.bool,
  handleProposalAfterSubmit: PropTypes.func
};
ConfirmModal.defaultProps = {
  possibleInterviewers: null,
  invitableRoles: null,
  modalTriggerType: 'link',
  buttonType: 'btn-primary',
  statusChangeId: null,
  isEditing: false,
  submitUrl: '',
  handleProposalAfterSubmit: function handleProposalAfterSubmit() {}
};
export default ConfirmModal;